import { Component, Input, Output, EventEmitter } from '@angular/core';
import { RegionalLocations } from '../models/regional-locations.model';
import { Location } from '../models/location.model';
import { ModalService } from '../modals/modal.service';
import { SpinnerService } from '../spinner/spinner.service';
import { AppointmentService } from '../services/appointment.service';
import { SlotAvailability } from '../models/slot-availability.model';
declare var $:any;

@Component({
    selector: 'region-list',
    templateUrl: 'region-list.component.html',
    standalone: false
})
export class RegionListComponent {

    @Input() regions: Array<RegionalLocations>;
    @Input() viewOnly: boolean = true;

    @Output() locationSelected: EventEmitter<Location> = new EventEmitter<Location>();

    public availableDate:Date = null;
    public isPopoverVisible:boolean = false;
    public availableMonth: string;
    public lastPublishedMonth: string;
    public lastPublishedDate:Date = null;

    constructor(private modal: ModalService, private spinner: SpinnerService, private appointmentService: AppointmentService) {}

    public getGoogleAddress(location: Location): string {
        if (location) {
            return 'http://maps.google.com/?q=' + location.address + ',%20' + location.city +
                    ',%20' + location.state + '%20' + location.postalCode;
        }
        return 'http://maps.google.com';
    }

    protected focusElement(tagID: string) {
        $('#' + tagID).focus();
    }

    public enlargeImage() {
        this.modal.notify('<img src="assets/images/USA_map.png" alt="U.S. map" class="img-fluid">',
                          'GENERAL_REUSABLE.REGION_LIST.MAP_HEADER', 'GENERAL_REUSABLE.BUTTON_LABEL.DONE');
    }

    public handleClosed(tagID: string) {
        this.isPopoverVisible = false;
    }

    public togglePopover(location:Location) {
        this.isPopoverVisible = this.isPopoverVisible ? false : true;
        this.availableDate = null;
        this.lastPublishedDate = null;
        if (this.isPopoverVisible) {
            this.spinner.show();
            this.appointmentService.getAppointmentAvailabilitySummary(location.id).subscribe( (res:SlotAvailability) => {
                if (res && res.availableDate) {
                    this.availableDate = res.availableDate;
                    this.availableMonth = this.getMonthKey(this.availableDate);
                } else {
                    this.availableDate = null;

                    if (res && res.lastPublishedDate) {
                        this.lastPublishedDate = res.lastPublishedDate;
                        this.lastPublishedMonth = this.getMonthKey(this.lastPublishedDate);
                    }
                }
                this.spinner.hide();
            },
            error => {
                // Silent failure. :(
                this.spinner.hide();
            });
        }

    }

    public getPosition(index: number): string {
        if((index + 1) % 3 === 0) {
            return 'left';
        } else {
            return 'right';
        }
    }

    public getMonthKey(slotDate: Date): string {

        let monthKey = 'GENERAL_REUSABLE.MONTHS.';
        switch (slotDate.getMonth() + 1) {
            case 1:
                monthKey += 'JANUARY';
                break;
            case 2:
                monthKey += 'FEBRUARY';
                break;
            case 3:
                monthKey += 'MARCH';
                break;
            case 4:
                monthKey += 'APRIL';
                break;
            case 5:
                monthKey += 'MAY';
                break;
            case 6:
                monthKey += 'JUNE';
                break;
            case 7:
                monthKey += 'JULY';
                break;
            case 8:
                monthKey += 'AUGUST';
                break;
            case 9:
                monthKey += 'SEPTEMBER';
                break;
            case 10:
                monthKey += 'OCTOBER';
                break;
            case 11:
                monthKey += 'NOVEMBER';
                break;
            case 12:
                monthKey += 'DECEMBER';
                break;
        }

        return monthKey;
    }
}
